import Card from './Card'

function MiniSpark({ color = 'text-ica-accent' }: { color?: string }) {
  return (
    <svg className={`h-8 w-16 ${color}`} viewBox="0 0 64 32" fill="none">
      <path
        d="M2 28 L12 20 L22 24 L32 8 L42 14 L52 10 L62 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}

export default function DashboardPreview() {
  return (
    <div className="mx-auto max-w-5xl">
      <div className="rounded-3xl border border-ica-border bg-ica-surface p-6 shadow-2xl shadow-black/40 md:p-8">
        {/* Top stat cards */}
        <div className="mb-6 grid gap-4 sm:grid-cols-3">
          <Card padding="sm" elevated className="flex items-center justify-between">
            <div className="space-y-1">
              <p className="text-xs font-medium text-ica-text-muted">Unpaid amount</p>
              <p className="text-xl font-bold">$3,450</p>
              <p className="text-xs text-ica-text-muted">4 active invoices</p>
            </div>
            <MiniSpark />
          </Card>
          <Card padding="sm" elevated className="flex items-center justify-between">
            <div className="space-y-1">
              <p className="text-xs font-medium text-ica-text-muted">Overdue invoices</p>
              <p className="text-xl font-bold">3</p>
              <p className="text-xs text-ica-red">2 reminders due</p>
            </div>
            <MiniSpark color="text-ica-red" />
          </Card>
          <Card padding="sm" elevated className="flex items-center justify-between">
            <div className="space-y-1">
              <p className="text-xs font-medium text-ica-text-muted">Paid this month</p>
              <p className="text-xl font-bold">$2,200</p>
              <p className="text-xs text-ica-accent">+18%</p>
            </div>
            <MiniSpark />
          </Card>
        </div>

        {/* Main area */}
        <div className="grid gap-4 lg:grid-cols-12">
          {/* Left column */}
          <div className="space-y-4 lg:col-span-3">
            <Card elevated padding="sm">
              <p className="text-xs font-medium text-ica-text-muted">Next reminder</p>
              <p className="mt-1 text-lg font-semibold">Northstar Studio</p>
              <p className="text-sm text-ica-text-secondary">$850 · 2 days overdue</p>
              <button className="mt-3 w-full rounded-lg bg-ica-accent py-2 text-xs font-semibold text-ica-accent-text transition-opacity hover:opacity-90">
                Mark paid
              </button>
            </Card>
          </div>

          {/* Main chart area */}
          <div className="lg:col-span-6">
            <Card elevated className="h-full">
              <div className="mb-4 flex items-center justify-between">
                <p className="text-sm font-medium">Follow-up overview</p>
                <div className="flex gap-3 text-xs text-ica-text-muted">
                  <span>Daily</span>
                  <span>Weekly</span>
                  <span className="text-ica-text">Monthly</span>
                </div>
              </div>
              <div className="relative h-48 w-full">
                <svg className="h-full w-full" viewBox="0 0 400 160" preserveAspectRatio="none">
                  <defs>
                    <linearGradient id="chartGrad" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="var(--accent)" stopOpacity="0.25" />
                      <stop offset="100%" stopColor="var(--accent)" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                  <path
                    d="M0 120 Q40 80 80 90 T160 60 T240 100 T320 50 T400 70 L400 160 L0 160 Z"
                    fill="url(#chartGrad)"
                  />
                  <path
                    d="M0 120 Q40 80 80 90 T160 60 T240 100 T320 50 T400 70"
                    fill="none"
                    stroke="var(--accent)"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <circle cx="320" cy="50" r="4" fill="var(--bg)" stroke="var(--accent)" strokeWidth="2" />
                </svg>
              </div>
            </Card>
          </div>

          {/* Right column */}
          <div className="lg:col-span-3">
            <Card elevated className="h-full">
              <p className="mb-3 text-sm font-medium">Reminder queue</p>
              <div className="space-y-3">
                {[
                  { label: 'Friendly reminder', tone: 'Friendly' },
                  { label: 'Overdue follow-up', tone: 'Firm' },
                  { label: 'Firm follow-up', tone: 'Firm' },
                  { label: 'Final reminder', tone: 'Final' },
                ].map((item, i) => (
                  <div key={i} className="flex items-center justify-between">
                    <div>
                      <p className="text-xs font-medium">{item.label}</p>
                      <p className="text-xs text-ica-text-muted">{item.tone}</p>
                    </div>
                    <div className="h-1.5 w-12 rounded-full bg-ica-elevated overflow-hidden">
                      <div
                        className="h-full rounded-full bg-ica-accent"
                        style={{ width: `${100 - i * 20}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}
